"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.perfectOrgData = perfectOrgData;
exports.queryOrgData = queryOrgData;
exports.queryUserPersonData = queryUserPersonData;
exports.updateUserPersonData = updateUserPersonData;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 用户个人信息
 * @returns {AxiosPromise}
 */
function queryUserPersonData() {
  return (0, _requestAuth.default)({
    url: '/sysUser/queryUserPersonData',
    method: 'get'
  });
}

/**
 * 更新个人信息
 * @param data
 * @returns {AxiosPromise}
 */
function updateUserPersonData(data) {
  return (0, _requestAuth.default)({
    url: '/sysUser/updateUserPersonData',
    method: 'put',
    data: data
  });
}

/**
 * 查看组织信息
 */
function queryOrgData() {
  return (0, _requestAuth.default)({
    url: '/sysUser/queryOrgData',
    method: 'get'
  });
}

/**
 * 完善组织信息
 * @param data
 * @returns {AxiosPromise}
 */
function perfectOrgData(data) {
  return (0, _requestAuth.default)({
    url: '/sysUser/perfectOrgData',
    method: 'put',
    data: data
  });
}